import classnames from 'classnames';
import { useRef, useEffect, RefObject, ComponentProps, ComponentPropsWithoutRef } from 'react';
import { BaseInput as BaseBaseInput } from './Input';
import useStyles from './InputComponent.styles';

type TBaseInputParams = ComponentProps<typeof BaseBaseInput>;

export interface IBaseInputProps extends ComponentPropsWithoutRef<'input'> {
  dark?: TBaseInputParams['dark'];
  error?: TBaseInputParams['error'];
  inputClass?: TBaseInputParams['inputClass'];
  /** User provided ref will override component made ref */
  inputElementRef?: RefObject<HTMLInputElement>;
  warning?: TBaseInputParams['warning'];
  textarea?: TBaseInputParams['textarea'];
}

const BaseInput = ({
  autoFocus,
  dark,
  error,
  id,
  inputClass,
  inputElementRef,
  warning,
  ...rest
}: IBaseInputProps) => {
  const ref = useRef<HTMLInputElement>(null);
  const classes = useStyles();
  useEffect(() => {
    if (autoFocus) {
      const refToUse = inputElementRef || ref;
      refToUse.current?.focus();
    }
  }, [autoFocus, inputElementRef]);

  return (
    <input
      ref={inputElementRef || ref}
      id={id}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      className={classnames(
        classes.input,
        {
          [classes.dark]: dark,
          [classes.error]: !!error,
          [classes.warning]: warning,
        },
        inputClass
      )}
    />
  );
};

export default BaseInput;
